var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "forgot-password-form" }, [
    _c("h3", { staticClass: "modal__title" }, [
      _vm._v(
        _vm._s(
          _vm.locales &&
            _vm.locales.common &&
            _vm.locales.common.forgot_password
        )
      )
    ]),
    _vm._v(" "),
    _c("h4", { staticClass: "modal__sub-title" }, [
      _vm._v(
        _vm._s(
          _vm.locales &&
            _vm.locales.common &&
            _vm.locales.common.forgot_password_text
        )
      )
    ]),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.capsLockEnabled,
          expression: "capsLockEnabled"
        }
      ],
      staticClass: "login-form__caps-warning",
      domProps: {
        textContent: _vm._s(
          _vm.locales.common && _vm.locales.common.capsWarning
        )
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "login-form__input-box" }, [
      _c("div", { staticClass: "login-form__label" }, [
        _vm._v(
          _vm._s(
            _vm.locales && _vm.locales.common && _vm.locales.common.your_email
          ) + "\n      "
        ),
        _c("span", { staticClass: "login-form__label-asterisk" }, [_vm._v("*")])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { position: "relative" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.forgotPasswordEmail,
              expression: "forgotPasswordEmail"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          class: [
            "login-form__input",
            { "login-form__input-invalid": _vm.errors.has("email") }
          ],
          attrs: {
            placeholder:
              _vm.locales &&
              _vm.locales.common &&
              _vm.locales.common.enter_your_email,
            type: "text",
            name: "email"
          },
          domProps: { value: _vm.forgotPasswordEmail },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.forgotPasswordSend.apply(null, arguments)
            },
            keypress: _vm.checkCaps,
            keydown: _vm.capsLockToggle,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.forgotPasswordEmail = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.has("email")
          ? _c("span", { staticClass: "icon-warning login-form__icon-error" })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.errors.has("email")
        ? _c("div", { staticClass: "login-form__error" }, [
            _vm._v("\n      " + _vm._s(_vm.errors.first("email")) + "\n    ")
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login-form__button-box" }, [
      _c(
        "button",
        {
          staticClass: "theme-btn theme-btn--theme theme-btn--block",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.forgotPasswordSend.apply(null, arguments)
            }
          }
        },
        [_vm._v("\n      Send email\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "theme-btn theme-btn--tertiary theme-btn--block",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.backToLogin.apply(null, arguments)
          }
        }
      },
      [
        _c("i", { staticClass: "icon-thin-left" }),
        _vm._v("\n    Go to Login\n  ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8efe5b2c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8efe5b2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/PasswordForm.vue
// module id = 576
// module chunks = 1